import styled from "styled-components";

export const BodyContainer = styled.div`
  background-color: #fdfdfd;
  min-height: 100vh;
  color: #000;
`;
